module.exports = __webpack_public_path__ + "static/media/PM28.60d66175.png";